module.exports = __webpack_public_path__ + "img/next_16.6f930f1d.svg";